import { customStyles } from '../../styles/customStyles';

const HeroSection = () => {
  return (
    <section className="relative max-w-7xl mx-auto px-6 pt-8 pb-12 lg:pt-12 lg:pb-24 min-h-[90vh] flex flex-col lg:flex-row items-center">
      <div className="w-full lg:w-1/2 z-20 relative">
        <div className="inline-block mb-6 px-4 py-1.5 border border-[#1F1F1F]/20 rounded-full bg-white/50 backdrop-blur-sm">
          <span className="font-typewriter text-[10px] uppercase tracking-widest flex items-center gap-2">
            <span className="w-2 h-2 bg-[#b7eb6f] rounded-full animate-pulse"></span>
            AI для карточек маркетплейсов
          </span>
        </div>

        <h1 className="text-5xl lg:text-7xl leading-[0.9] mb-8 text-[#1F1F1F] font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Создавайте<br />
          <span className="italic ml-8 text-[#b7eb6f]">карточки,</span><br />
          которые<br />
          <span className="font-light ml-4">продают</span>
        </h1>

        <p className="font-sans text-lg lg:text-xl opacity-80 max-w-md leading-relaxed mb-10 border-l-2 border-[#1F1F1F]/10 pl-6">
          Анализ конкурентов, AI-тестирование и генерация визуала за минуты вместо дней. Без дизайнеров и ручной работы.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mb-16">
          <a href="https://trippika.ru/seller-login" className="px-8 py-4 bg-[#b7eb6f] text-[#1F1F1F] rounded-lg font-typewriter text-sm uppercase tracking-widest shadow-[4px_4px_0px_0px_rgba(31,31,31,1)] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_0px_rgba(31,31,31,1)] hover:bg-[#b7eb6f] transition-all border border-[#1F1F1F] inline-block text-center">
            Создать бесплатно →
          </a>
          <a href="https://trippika.ru/seller-login" className="px-8 py-4 bg-transparent text-[#1F1F1F] rounded-lg font-typewriter text-sm uppercase tracking-widest border border-[#1F1F1F] hover:bg-[#1F1F1F] hover:text-white transition-all flex items-center gap-2">
            <i className="ph ph-play-circle text-lg"></i>
            Посмотреть демо
          </a>
        </div>

        <div className="flex items-center gap-8 font-typewriter text-xs opacity-60 border-t border-[#1F1F1F]/10 pt-6 max-w-md">
          <div className="flex flex-col gap-1">
            <span className="text-xl font-serif-display italic text-[#1F1F1F]">60 сек</span>
            <span>на карточку</span>
          </div>
          <div className="w-px h-8 bg-[#1F1F1F]/20"></div>
          <div className="flex flex-col gap-1">
            <span className="text-xl font-serif-display italic text-[#1F1F1F]">4 AI</span>
            <span>агента</span>
          </div>
          <div className="w-px h-8 bg-[#1F1F1F]/20"></div>
          <div className="flex flex-col gap-1">
            <span className="text-xl font-serif-display italic text-[#1F1F1F]">10+</span>
            <span>стилей</span>
          </div>
        </div>
      </div>

      <div className="relative h-[600px] flex items-center justify-center">
        {/* Декоративный круг на фоне */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] border border-[#1F1F1F]/5 rounded-full"></div>

        {/* Задняя карточка — зелёная, выглядывает справа сверху */}
        <div className="absolute -top-16 right-0 w-64 h-80 bg-[#b7eb6f] rounded-sm rotate-12 overflow-hidden" style={customStyles.paperCard}>
          <img 
            src="/generated-1771170992425.png" 
            alt="Background" 
            className="w-full h-full object-cover"
          />
        </div>

        {/* Основная карточка — спереди по центру */}
        <div className="absolute w-[340px] h-[480px] bg-[#F4F1EA] rounded-lg border border-[#1F1F1F]/10 flex flex-col overflow-hidden" style={{ ...customStyles.paperCard, zIndex: 20, transform: 'rotate(-1deg)', top: '-5%', right: '0' }}>
          <div className="h-8 border-b border-[#1F1F1F]/10 flex items-center px-4 gap-2">
            <div className="w-2 h-2 rounded-full bg-[#b7eb6f]"></div>
            <div className="w-2 h-2 rounded-full bg-[#b7eb6f]"></div>
            <div className="w-full text-center font-typewriter text-[8px] opacity-40">Стиль креативный</div>
          </div>
          <div className="p-6 flex-1 flex flex-col gap-4">
            <div className="w-full bg-[#1F1F1F] rounded flex items-center justify-center relative overflow-hidden" style={{ aspectRatio: '3/4' }}>
              <img 
                src="/2026-02-23 12.24.01.jpg" 
                alt="Product" 
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-[#F4F1EA] px-3 py-1 rounded-full font-typewriter text-[10px] uppercase">CTR +47%</div>
            </div>
            <div className="space-y-2">
              <div className="h-2 w-3/4 bg-[#1F1F1F]/5 rounded"></div>
              <div className="h-2 w-1/2 bg-[#1F1F1F]/5 rounded"></div>
            </div>
            <div className="mt-auto flex justify-between items-center">
              <div className="flex -space-x-2">
                <div className="w-6 h-6 rounded-full bg-[#b7eb6f] border-2 border-[#F4F1EA]"></div>
                <div className="w-6 h-6 rounded-full bg-[#b7eb6f] border-2 border-[#F4F1EA]"></div>
              </div>
              <a href="https://trippika.ru/seller-login" className="bg-[#1F1F1F] text-white px-4 py-1.5 rounded text-xs font-typewriter inline-block">Скачать</a>
            </div>
          </div>
        </div>

        {/* Пунктирная стрелка снизу */}
        <svg className="absolute -bottom-10 left-20 w-32 h-32 text-[#1F1F1F] rotate-12" viewBox="0 0 100 100">
          <path d="M10,80 Q50,90 80,40" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="4 2" markerEnd="url(#arrowhead)" />
          <defs>
            <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
              <polygon points="0 0, 10 3.5, 0 7" fill="currentColor" />
            </marker>
          </defs>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
